










































































































































































import { Component, Prop } from "vue-property-decorator";
import {ScrollButton} from "wings-ui-components";
import { Getter } from "vuex-class";
import { IncomingTariffsItem } from "@/store/tarification/incoming_tariffs/types";
import BaseItemsPage from "../BaseItemsPage";
import { MsgTransports } from "@/store/types";
import IncomingTariffsFilter from "@/components/Tarification/IncomingTariffsFilter.vue";

@Component({ components: { IncomingTariffsFilter, ScrollButton } })
export default class IncomingTariffs extends BaseItemsPage<IncomingTariffsItem> {
  @Prop() transport!: MsgTransports;

  @Getter("incomingTariffs") responseItems!: IncomingTariffsItem[];

  is_show_filter = false;

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      "id",
      "service_number",
      "service_provider",
      "regexp",
      "partner",
      "broker_account",
      "priority",
    ];
  }

  getData(): IncomingTariffsItem[] {
    return this.responseItems;
  }
}
